import React, { useRef, useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import MainPagetitle from "../../../layouts/MainPagetitle";
import { Link } from 'react-router-dom';
import axios from "axios";

const BankStatementAnalyzer = (props) => {
  const DIGITAP_BSA_UPLOAD = `${endpoints[environment].api_base}/api/v1/toolkit/admin/digitap-bsa/upload`;
  const DIGITAP_BSA_STATUS = `${endpoints[environment].api_base}/api/v1/toolkit/admin/digitap-bsa/status-check`;
  const DIGITAP_BSA_RETRIEVE = `${endpoints[environment].api_base}/api/v1/toolkit/admin/digitap-bsa/retrieve-report`;

  const bsaForm = useRef(null);
  
  const [passcheck, setPasscheck] = useState(false);
  const [bsaStep, setBsaStep] = useState('upload'); // 'upload', 'uploading', 'processing', 'success', 'error'
  const [bsaReportUrls, setBsaReportUrls] = useState(null);
  const [bsaErrorMsg, setBsaErrorMsg] = useState(null);

  const handlePasswordCheck = (e) => {
    let value = e.target.checked;
    setPasscheck(value);
  };

  const handleReset = () => {
    setBsaStep('upload');
    setBsaReportUrls(null);
    setBsaErrorMsg(null);
    setPasscheck(false);
  };

  const retrieveReport = async (request) => {
    let authToken = props?.$store?.auth;
    try {
      const response = await axios.post(DIGITAP_BSA_RETRIEVE, {
        txn_id: String(request.txn_id),
        report_type: "json",
        report_subtype: "type3"
      }, {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response.data?.result) {
        setBsaReportUrls({
          excelLink: response?.data?.result?.excelLink,
          jsonLink: response?.data?.result?.jsonLink
        });
        setBsaStep('success');
      } else {
        setBsaErrorMsg("Failed to retrieve report data.");
        setBsaStep('error');
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        props?.apis?.applogout();
      }
      let message = error.response?.data?.message || error.response?.data?.msg || "Error retrieving report";
      setBsaErrorMsg(message);
      setBsaStep('error');
    }
  };

  const pollStatus = async (request) => {
    let authToken = props?.$store?.auth;
    let iterationcount = 0;
    
    const check = async () => {
      try {
        const response = await axios.post(DIGITAP_BSA_STATUS, {
          request_id: String(request.request_id)
        }, {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        });
        
        let txn_status = response?.data?.txn_status || [];
        let statusObj = txn_status.length > 0 ? txn_status[0] : null;
        
        if (statusObj && statusObj.code === "ReportGenerated") {
          retrieveReport(request);
        } else if (statusObj && statusObj.status === "Failure") {
          setBsaErrorMsg(statusObj.msg || "Analysis failed.");
          setBsaStep('error');
        } else {
          if (iterationcount >= 40) {
            setBsaErrorMsg("Analysis is taking too long to respond. Please try again.");
            setBsaStep('error');
          } else {
            iterationcount++;
            setTimeout(check, 3000);
          }
        }
      } catch (error) {
        if (error?.response?.status === 401) {
          props?.apis?.applogout();
        }
        let message = error.response?.data?.message || error.response?.data?.msg || "Error checking status";
        setBsaErrorMsg(message);
        setBsaStep('error');
      }
    };
    
    setTimeout(check, 3000);
  };

  const handleBsaSubmit = async (e, data) => {
    if (!data.file) {
      swal2.fire({
        icon: "warning",
        title: "Please upload a Bank Statement"
      });
      return;
    }

    let payload = { file: data.file };
    if (passcheck && data.statement_file_password) {
      payload.file_password_b16 = data.statement_file_password;
    }
    
    setBsaStep('uploading');
    let authToken = props?.$store?.auth;

    try {
      const response = await axios.post(DIGITAP_BSA_UPLOAD, payload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${authToken}`,
        },
      });

      if (response?.data?.status === "success" && response?.data?.request_id && response?.data?.txn_id) {
        const newRequest = {
          request_id: String(response?.data?.request_id),
          txn_id: String(response?.data?.txn_id),
        };
        setBsaStep('processing');
        pollStatus(newRequest);
      } else {
        setBsaErrorMsg(response.data?.message || "Upload successful, but no tracking IDs received.");
        setBsaStep('error');
      }
    } catch (error) {
      if (error?.response?.status === 401) {
        props?.apis?.applogout();
      }
      let message = error.response?.data?.message || error.response?.data?.msg || "Failed to upload Bank Statement";
      setBsaErrorMsg(message);
      setBsaStep('error');
    }
  };

  const getMainTitle = () => {
    return "Know Your Customer";
  };

  const getBreadCums = () => {
    return "Bank Statement Analyzer";
  };

  props.$setNode({
    props,
    bsaForm,
  });

  return (
    <>
      <MainPagetitle
        mainTitle={getMainTitle()}
        back={getBreadCums()}
        backLink={`/app/kyc`}
        pageTitle={"Bank Statement Analyzer"}
        parentTitle={"KYC"}
        pageIcon={imagepaths.PersonSearchIconActive}
      />
      <div className="container-fluid">
        <div className="mb-4">
          <Link
            to={'/app/kyc'}
            className="fw-bold text-decoration-none d-inline-flex align-items-center"
            style={{ color: '#372626' }}
          >
            <i className="fa-solid fa-arrow-left me-2" style={{ color: '#372626' }}></i>Go Back
          </Link>
        </div>
        <div className="card p-4 bsa_card border-0 shadow-sm">
          <div className="row">
            <div className="col-12 col-md-6 col-lg-6 col-xl-7">
              <h2 className="title mb-3">What is Bank Statement Analyzer?</h2>
              <p className="text-muted" style={{ lineHeight: '1.8' }}>
                We at Impetus AI Solutions, are focused on providing analytical
                services to financial institutes. We provide robust technology
                driven services, and with our experience with the financial
                industry, we understand how difficult it is for financial
                institutions to perform these credit checks. We are offering a
                state of the art Bank Statement Analyzer that uses machine
                learning and artificial intelligence to scan your applicant's
                bank statements, and performs a series of checks, giving results
                on whether the statement is trustworthy or not.
              </p>
            </div>
            <div className="col-12 col-md-6 col-lg-6 col-xl-5 bsa_form_column bsa_modal_content bg-white p-4 rounded border">

              {(bsaStep === 'upload' || bsaStep === 'uploading') && (
                <>
                  <h4 className="mb-4">Upload Statement</h4>
                  <AppForm onSubmit={(...args) => handleBsaSubmit(...args)} ref={bsaForm}>
                    <div className="col-12 mb-3">
                      <AppInput
                        type="defaultfile"
                        name="file"
                        label="Bank Statement (.pdf or .xlsx)"
                        foldername="bsaDocs"
                        required={true}
                      />
                    </div>
                    <Form.Check
                      type="checkbox"
                      id="passcheck"
                      label="Password protected"
                      className="ms-3 mb-3"
                      checked={passcheck}
                      onChange={handlePasswordCheck}
                    />
                    {passcheck && (
                      <div className="col-12 mb-3">
                        <AppInput
                          type="text"
                          label="Password"
                          name="statement_file_password"
                        />
                      </div>
                    )}
                    <div className="col-12 text-end mt-4">
                      <button
                        type="submit"
                        className="btn btn-primary px-5 py-3 w-100 d-flex align-items-center justify-content-center"
                        disabled={bsaStep === 'uploading'}
                      >
                        {bsaStep === 'uploading' ? (
                          <>
                            <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                            Uploading...
                          </>
                        ) : (
                          "Upload Statement"
                        )}
                      </button>
                    </div>
                  </AppForm>
                </>
              )}

              {bsaStep === 'processing' && (
                <div className="text-center py-4">
                  <div className="spinner-border text-primary mb-3" style={{ width: '3rem', height: '3rem' }} role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                  <h4 className="mb-2">Analyzing Bank Statement</h4>
                  <p className="text-muted mb-4">
                    The statement is currently being analyzed in the background.
                    This process usually takes a few moments. Please wait...
                  </p>
                </div>
              )}

              {bsaStep === 'success' && (
                <div className="text-center py-4">
                  <div className="mb-3">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#28a745" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path>
                      <polyline points="22 4 12 14.01 9 11.01"></polyline>
                    </svg>
                  </div>
                  <h4 className="mb-3 text-success">Analysis Complete!</h4>
                  <p className="text-muted mb-4">The bank statement has been successfully analyzed.</p>

                  <div className="d-flex flex-column gap-3">
                    {bsaReportUrls?.excelLink && (
                      <a href={bsaReportUrls.excelLink} target="_blank" rel="noopener noreferrer" className="btn btn-primary w-100 py-2">
                        Download Excel Report
                      </a>
                    )}
                    <button type="button" className="btn btn-outline-primary w-100 py-2 mt-2" onClick={handleReset}>
                      Analyze Another
                    </button>
                  </div>
                </div>
              )}

              {bsaStep === 'error' && (
                <div className="text-center py-4">
                  <div className="mb-3">
                    <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="#dc3545" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <circle cx="12" cy="12" r="10"></circle>
                      <line x1="15" y1="9" x2="9" y2="15"></line>
                      <line x1="9" y1="9" x2="15" y2="15"></line>
                    </svg>
                  </div>
                  <h4 className="mb-3 text-danger">Analysis Failed</h4>
                  <p className="text-muted mb-4">{bsaErrorMsg}</p>

                  <div className="d-flex flex-column gap-3">
                    <button type="button" className="btn btn-primary w-100 py-3" onClick={handleReset}>
                      Try Again
                    </button>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default constore(BankStatementAnalyzer);
